/*
 * @Author: ZJJ
 * @Date: 2025-11-05 19:13:16
 * @LastEditTime: 2025-11-26 15:35:38
 * @FilePath: /boluo_website/src/store/index.js
 * @Description:
 */
import Vue from "vue";
import Vuex from "vuex";
import audio from "./modules/audio";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isShowPayDialog: false, //是否显示微信支付弹窗
    payInfo: {}, // 微信支付信息(主要是二维码支付信息)
    shouldRefreshBasicInfo: false, // 是否刷新基础信息 主要针对专栏处的详情及列表
    shouldTriggerLogout: false, // 退出登录信号
    payType: 0, //当前需要被付款的类型 (1=有声书, 2=课程)
    lessionOrAudioBookId: 0 // 付款的课程或有声书的id
  },
  getters: {},
  mutations: {
    setPayInfo(state, value) {
      state.payInfo = value;
    },

    SET_IS_SHOW_PAY_DIALOG(state, payload) {
      state.isShowPayDialog = payload;
    },

    SET_PAY_TYPE(state, payType) {
      state.payType = payType;
    },

    SET_PAY_ID(state, payId) {
      state.lessionOrAudioBookId = payId;
    },

    SET_REFRESH_BASIC_INFO(state, payload) {
      state.shouldRefreshBasicInfo = payload;
    },

    SET_TRIGGER_LOGOUT(state, payload) {
      state.shouldTriggerLogout = payload;
    }
  },
  actions: {
    closePayDialog({ commit }) {
      commit("SET_IS_SHOW_PAY_DIALOG", false);
      document.body.style.overflow = "";
    },
    openPayDialog({ commit }, payload) {
      const { payType, lessionOrAudioBookId } = payload;
      commit("SET_IS_SHOW_PAY_DIALOG", true);
      commit("SET_PAY_TYPE", payType);
      commit("SET_PAY_ID", lessionOrAudioBookId);
    },

    // 触发更新专栏的详情及列表信息
    refreshBasicInfo({ commit }) {
      commit("SET_REFRESH_BASIC_INFO", true);
      // 重置状态，避免重复触发
      let timer = setTimeout(() => {
        commit("SET_REFRESH_BASIC_INFO", false);
        clearTimeout(timer);
      }, 100);
    },

    // 触发退出登录
    triggerLogout({ commit }) {
      commit("SET_TRIGGER_LOGOUT", true);
      let timer = setTimeout(() => {
        commit("SET_TRIGGER_LOGOUT", false);
        clearTimeout(timer);
      }, 100);
    }
  },
  modules: {
    audio
  }
});
